function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const defaultOptions = {
  backgroundColor: 'rgb(255, 255, 0)',
  fontStyle: 'italic',
  color: 'inherit',
};

/**
 * Highlights keywords in HTML content
 * @param {string} htmlContent - The HTML string to search within
 * @param {string[]} keywords - Array of keywords to highlight
 * @param {Object} options - Styling options for the highlight
 * @returns {string} The HTML string with keywords highlighted
 */
export function highlightKeywordsInHtml(htmlContent, keywords, options = {}) {
  const { backgroundColor, fontStyle, color } = { ...defaultOptions, ...options };
  let highlightedHtml = htmlContent;

  keywords.forEach(keyword => {
    if (!keyword) return;

    // Create a regex that matches the keyword case-insensitively
    const regex = new RegExp(`(${escapeRegExp(keyword)})`, 'gi');

    highlightedHtml = highlightedHtml.replace(regex, (match) => {
      return `<mark style="background-color: ${backgroundColor}; font-style: ${fontStyle}; color: ${color};">${match}</mark>`;
    });
  });

  return highlightedHtml;
}

/**
 * Highlights keywords in all elements matching the selector within containers
 * @param {string} containerSelector - Selector for container elements (e.g., '.js-highlight-container')
 * @param {string} elementSelector - Selector for elements to highlight within (e.g., '.js-highlight')
 * @param {Function} getKeywords - Function to extract keywords from container and element
 * @param {Object} options - Styling options for the highlight
 */
export function highlightElementsInContainers(containerSelector, elementSelector, getKeywords, options = {}) {
  const containers = document.querySelectorAll(containerSelector);

  containers.forEach(container => {
    const elements = container.querySelectorAll(elementSelector);

    elements.forEach(element => {
      const keywords = getKeywords(container, element);
      if (keywords.length === 0) return;

      const originalHtml = element.innerHTML;
      const highlightedHtml = highlightKeywordsInHtml(originalHtml, keywords, options);

      if (highlightedHtml !== originalHtml) {
        element.innerHTML = highlightedHtml;
      }
    });
  });
}
